export const cn = (...classNames: (string | undefined | false)[]): string =>
  classNames.filter(Boolean).join(" ");

export const cond = (condition: boolean, className: string): string =>
  condition ? className : "";
